// extracted by mini-css-extract-plugin
export default {"popup":"MessagePromotions_popup__iPS9C","popupContent":"MessagePromotions_popupContent__nBXhr","buttons":"MessagePromotions_buttons__zpW-n"};